<template lang="pug">
  .collapse-wrapper(:class="{openLine}")
    .header
      .header__event-date
        p {{ getDate }}
      .header__event-container(@click="toggle")
        p.header__event-title(:class="getType")  {{eventTitle}}
        .header__event-toggle
          .header__toggler(:class="{open}")
    transition(name="collapse")
      .content(v-show="open")
        slot
</template>
<script>
import LeiPopover from '../lei-components/LeiPopover'
import record from '../../constants/tooltips/record'
import { shortDateFormat, } from '../../store/helpers'

export default {
  components: {
    LeiPopover,
  },
  props: {
    eventTitle: {
      type: String,
      required: true,
    },
    eventType: {
      type: String,
      required: true,
    },
    eventDate: {
      type: String,
      required: true,
      default: null,
    },
  },

  data () {
    return {
      tooltips: record,
      open: true,
      openLine: false,
    }
  },
  computed: {
    getDate () {
      return this.eventDate ? shortDateFormat(this.eventDate) : 'Date unavailable'
    },
    getType () {
      if (this.eventType === 'COMPLETED') return { completed: true, }
      if (this.eventType === 'IN_PROGRESS') return { progress: true, }
      if (this.eventType === 'WITHDRAWN_CANCELLED') return { withdrawn: true, }
      return {}
    },
  },
  methods: {
    toggle () {
      this.open = !this.open
      this.openLine = !this.openLine
    },
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .openLine
    &:last-child
      &>.header::after
        display none

  .collapse-wrapper
    display flex
    flex-direction column
    width 100%
    &:first-child
      &>.header::before
        display none

    .header
      width 100%
      display flex
      align-items center
      margin-top 40px
      margin-left 9px
      position relative
      &::before
        content ''
        position absolute
        top -41px
        left 0
        display inline-block
        width 2px
        height 60px
        border-radius 2px
        background: $default-color-light-1
      &::after
        content ''
        position absolute
        top 41px
        left 0
        display inline-block
        width 2px
        height 19px
        border-radius 2px
        background: $default-color-light-1

      &__event-date
        width 20%
        color $default-color-bold-1
        padding-left 35px
        font-weight 700
        position relative
        &::before
          content ''
          position absolute
          top 0
          left -7px
          display inline-block
          width 16px
          height 16px
          border-radius 2px
          background: $default-color-bold-1

      &__event-container
        cursor pointer
        width 80%
        height 60px
        background-color $default-color-light-1
        display flex
        align-items center
      &__event-title
        flex-grow 1
        color $default-color-bold-1
        padding-left 50px
        position relative
        &::before
          content ''
          position absolute
          top 0
          left 20px
          display inline-block
          width 15px
          height 15px
          border-radius 7.5px
        &.completed
          &::before
            background-color $success-color
        &.progress
          &::before
            background-color $warning-color
        &.withdrawn
          &::before
            background-color $danger-color

      &__event-toggle
        width 35px
        height 35px
        margin-right 20px
        position relative
      &__toggler
        position absolute
        top: 3px;
        left 8px
        width 20px
        height 20px
        transform: rotate(-135deg);
        border-left 4px solid  $default-color-bold-1
        border-top 4px solid  $default-color-bold-1
        border-radius 2px
        &.open
          top: 15px;
          transform: rotate(45deg);

      .title
        color $default-color-bold
        font-weight 600

        &.lei-code
          display flex
          align-items center

      .toggle
        color $default-color
        font-weight 600
        text-decoration underline

    .content
      transform-origin top
      overflow hidden
      height auto
      transition transform .15s cubic-bezier(1.0, 0.5, 0.8, 1.0)
      margin-left 9px
      border-left 2px solid $default-color-light-1

  .collapse-enter-active
    transform scaleY(1)

  .collapse-enter, .collapse-leave-to
    transform scaleY(0)

  @media screen and (max-width: $laptop-l)
    .collapse-wrapper
      .header
        max-width auto

      .content
        max-width auto

  @media screen and (max-width: $tablet)
    .collapse-wrapper
      .content
        border none
        margin 0
      .header
        margin 20px 0 0
        &__event-title
          width 80%
          word-break break-word
        &__event-date
          display none
        &__event-container
          width 100%
        &::before
          display none
        &::after
          display none

</style>



// WEBPACK FOOTER //
// src/components/lei-components/CollapseTimelineComponent.vue